export default __webpack_public_path__ + "static/media/896.f42f5766.png";